import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Card, Chip, Stack, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { DopsStatusChip, DopsSummary, OVERALL_COLORS, formatDate } from './dopsShared'

// Clickable list of DOPS rows, opening /dops/:id. `role` decides which
// name is shown ('assessor' shows the trainee, 'trainee' the assessor,
// anything else both).
const DopsList = ({ items, role, empty }) => {
  const navigate = useNavigate()
  if (!items.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
        {empty}
      </Typography>
    )
  }
  return (
    <Card variant="outlined" sx={{ borderRadius: 2.5 }}>
      {items.map((dops, index) => (
        <Stack
          key={dops._id}
          direction="row"
          alignItems="center"
          gap={1.5}
          px={1.5}
          py={1}
          onClick={() => navigate(`/dops/${dops._id}`)}
          sx={{
            cursor: 'pointer',
            borderTop: index ? 1 : 0,
            borderColor: 'divider',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <Box flex={1} minWidth={0}>
            <DopsSummary dops={dops} role={role} />
            <Typography variant="caption" color="text.secondary" component="div" noWrap>
              Requested {formatDate(dops.createdAt)}
              {dops.completedAt ? ` · completed ${formatDate(dops.completedAt)}` : ''}
            </Typography>
          </Box>
          <Stack alignItems="flex-end" gap={0.5} flexShrink={0}>
            <DopsStatusChip status={dops.status} />
            {dops.overall && (
              <Chip
                size="small"
                variant="outlined"
                label={dops.overall}
                color={OVERALL_COLORS[dops.overall] ?? 'default'}
                sx={{ borderRadius: 1, display: { xs: 'none', md: 'inline-flex' } }}
              />
            )}
          </Stack>
          <ChevronRightIcon color="action" />
        </Stack>
      ))}
    </Card>
  )
}

export default DopsList
